import { useCallback, useContext, useEffect, useState } from 'react';
import { useLoaderData, useNavigate } from 'react-router-dom';
import { useImmerReducer } from 'use-immer';
import PageBuilder from '../../../../library/Builders/PageBuilder/PageBuilder';
import { GlobalContext } from '../../../../library/Core/GlobalContext';
import { SmartContext } from '../../../../library/Core/SmartContext';
import smartReducer from '../../../../library/Core/SmartReducer';
import { DispatchEvent, State } from '../../../../library/Core/SmartTypes';
import { addUserSpecificDomains } from '../../../../library/Service/domainService';
import { handleNext } from './OutcomeActions';
import OutcomeLayout from './OutcomeLayout';
import SessionContext from '../../../../library/Core/SessionContext';
import axios from 'axios';
import { getFlexColDomainValueForCode, isEmpty } from '../../../../library/Core/SmartFunctions';
import { axiosClient } from '../../../../library/Service/axiosClient';
import OutcomeInformationLayout from '../OutcomeInformationLayout';
import { Domain } from 'domain';

const Outcome = () => {
    const { globalState } = useContext(GlobalContext);
    const navigate = useNavigate();
    const [redirectUrl, setRedirectUrl] = useState('');
    let programLevel = '';
    const { sessionState, sessionDispatch } = useContext(SessionContext);
    
    const [state, dispatch] = useImmerReducer<State, DispatchEvent>(smartReducer, {
        flags: { isDataLoading: true, showFormErrors: 0 },
        formValidationErrors: {},
        actions: {
            NEXT: handleNext,
            ROUTER_NAVIGATE: navigate,
            REDIRECT: setRedirectUrl,
            // startYear:  handleStartYearChange,
            sessionState: sessionState,
        },
    } as any);

    const { formConfig, data, internal, routeInfo } = useLoaderData() as State;
    const getSocialProfileLinks = () => {
        return globalState.domain?.get('SOCIAL_NETWORK_CODE')?.map((item: any) => ({ socialNetworkCode: item.code, link: '' }));
    };
    useEffect(() => {
        if (redirectUrl !== '') {
            navigate(redirectUrl);
        }
    }, [redirectUrl]);

    useEffect(() => {
    if (sessionState?.userTypeCode === 'SUPER_ADMIN' || sessionState?.userTypeCode === 'INSTITUTE_ADMIN') {
        if (localStorage.getItem('selectedInstitute') === undefined) {
            return navigate(`/alumni/${data?.id}/select-institute`);
        }
    }

    const getProgramLevel = async () => {
        const response = await axiosClient().get(
            `${process.env.REACT_APP_COMMON_API}/users/get-program-level-by-program-id/${data?.selectedInstitute?.programId}`
        );

        if (response.data.success === 1) {
            const programLevelResponse = response.data.data.programLevel;
            programLevel = programLevelResponse;
        }
    };

    const domainMap = new Map([...globalState.domain]);
    const domain = addUserSpecificDomains(new Map([...domainMap]), data);
    const statuses = domain.get('POST_PROGRAM_COMPLETION_STATUS_CODE');

    if (statuses?.length) {
        const normalStatuses: any[] = [];
        const workingStatuses: any[] = [];

        statuses.forEach((status: any) => {
            if (!status.flexCol) {
                normalStatuses.push(status);
                return;
            }

            let flex = status.flexCol;

            if (typeof flex === 'string') {
                try {
                    flex = JSON.parse(flex);
                } catch {
                    normalStatuses.push(status);
                    return;
                }
            }

            if (flex?.is_working === 1) {
                workingStatuses.push(status);
            } else {
                normalStatuses.push(status);
            }
        });

        domain.set('POST_PROGRAM_COMPLETION_STATUS_CODE', normalStatuses);
        domain.set('POST_PROGRAM_COMPLETION_STATUS_CODE_WORKING', workingStatuses);
    }

    const loadSchoolSettings = async () => {
        const response = await axios.get(
            `${process.env.REACT_APP_PAGE_CONFIG_SERVER}/v1/appConfig/outcome-page-program-domain-data/${data?.selectedInstitute?.instituteId}`
        );

        domainMap.set('INSTITUTE_PROGRAM_CODE', response.data);

        dispatch({
            type: 'DATA_INIT',
            payload: {
                formConfig,
                data: {
                    ...data,
                    selectedInstitute: {
                        ...data?.selectedInstitute,
                        showOutcomeMainStep: true,   // 👈 STEP FLAG ADDED HERE
                    },
                },
                internal,
                domain,
                routeInfo,
            },
        });
    };

    if (!isEmpty(data?.selectedInstitute)) loadSchoolSettings();
    if (isEmpty(sessionState?.programLevel)) getProgramLevel();
}, []);

    useEffect(() => {
        const selectedInstitute = state?.data?.selectedInstitute;
        if (!selectedInstitute) return;

        if (selectedInstitute.postProgramCompletionStatusCode === 'WORKING') {
            if (selectedInstitute.showOutcomeMainStep !== false) {
                dispatch({
                    type: 'REFRESH_DATA',
                    payload: {
                        data: {
                            ...state.data,
                            selectedInstitute: {
                                ...selectedInstitute,
                                showOutcomeMainStep: false,
                            },
                        },
                    },
                });
            }
        } else {
            if (selectedInstitute.showOutcomeMainStep !== true) {
                dispatch({
                    type: 'REFRESH_DATA',
                    payload: {
                        data: {
                            ...state.data,
                            selectedInstitute: {
                                ...selectedInstitute,
                                showOutcomeMainStep: true,
                                
                            },
                        },
                    },
                });
            }
        }
    }, [state?.data?.selectedInstitute?.postProgramCompletionStatusCode]);

    let postProgramCompletionStatusCode = state?.data?.selectedInstitute?.postProgramCompletionStatusCode;
    console.log("postProgramCompletionStatusCode",postProgramCompletionStatusCode)
    const flexCol = getFlexColDomainValueForCode(postProgramCompletionStatusCode, 'POST_PROGRAM_COMPLETION_STATUS_CODE_WORKING', state);
    console.log("flexCol",flexCol)
    const is_working = isEmpty(flexCol) ? '' : JSON.parse(flexCol).is_working;
    const higherStudyOptions = ['JOINED_SCHOOL', 'JOINED_UG', 'JOINED_PG', 'JOINED_DOCTORAL'];
    if (higherStudyOptions.includes(postProgramCompletionStatusCode) || is_working) {
        postProgramCompletionStatusCode = is_working ? 'WORKING' : 'WENT_FOR_HIGHER_STUDIES';

        let selectedInstitute = { ...state?.data?.selectedInstitute };
        selectedInstitute.postProgramCompletionStatusCode = postProgramCompletionStatusCode;

        dispatch({ type: 'REFRESH_DATA', payload: { data: { ...state?.data, selectedInstitute: selectedInstitute } } });
    }

    return (
        <SmartContext.Provider value={{ state, dispatch }}>
            {/* <OutcomeLayout>{!state.flags.isDataLoading && <PageBuilder />}</OutcomeLayout> */}
            <OutcomeInformationLayout>
                {!state.flags.isDataLoading && <PageBuilder />}
            </OutcomeInformationLayout>    
        </SmartContext.Provider>
    );
};

export default Outcome;
